module.exports = __webpack_public_path__ + "static/media/foto3.3d0a44ba.png";